import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Success from "./pages/Manager";
import Error from "./pages/Error";
import "./App.css"

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/manager" element={<Success />} />
        <Route path="/error" element={<Error />} />
      </Routes>
    </Router>
  );
};

export default App;